module.exports = __webpack_public_path__ + "img/bgc14.77b03b01.png";